import React, { useEffect, Fragment } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Helmet } from 'react-helmet-async';
import MediaQuery from 'react-responsive';
import { ReactSVG } from 'react-svg';
import { Navigation } from 'react-minimal-side-navigation';
// import isEmpty from '../../../../validation/is-empty';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faPizzaSlice,
  faUserClock,
  faStopwatch20,
  // faUserAstronaut,
  faFileCertificate,
  // faExclamationTriangle,
  faCog,
} from '@fortawesome/pro-regular-svg-icons';
// import { faAmazon } from '@fortawesome/free-brands-svg-icons';

import './SideNav.scss';

function SideNav({ user, open, setOpen, sideNavFixed, cvList, ...props }) {
  const history = useHistory();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!open) document.body.classList.remove('no-refresh');
  }, [open]);

  function onClickOption(newPath = null) {
    if (!sideNavFixed) setOpen(!open);
  }

  return (
    <Fragment>
      <nav
        id="_admin-side-nav_"
        className={classnames(null, {
          open: sideNavFixed ? sideNavFixed : open,
        })}
      >
        {open && !sideNavFixed && (
          <Helmet>
            <body class="no-refresh" />
          </Helmet>
        )}
        <MediaQuery minWidth={1280}>
          <div className="facti-logo-header">
            <ReactSVG
              wrapper="span"
              className="logo"
              src="/assets/img/facti-new-logo (white).svg"
              fallback={() => <span>Facti - logo</span>}
              afterInjection={(error, svg) => {
                if (error) return console.error(error);
                svg.removeAttribute('data-src');
              }}
              onClick={() => history.push('/home')}
            />
            <svg
              className="curve"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              <path
                d="M741,116.23C291,117.43,0,27.57,0,6V120H1200V6C1200,27.93,1186.4,119.83,741,116.23Z"
                className="shape-fill"
              ></path>
            </svg>
          </div>
        </MediaQuery>

        <section>
          <h3>ADMIN</h3>
          <ul>
            <li>
              <NavLink
                className="section"
                activeClassName="is-active"
                exact
                to="/home"
                onClick={() => onClickOption('/home')}
              >
                <FontAwesomeIcon icon={faHome} />
                Dashboard
              </NavLink>
            </li>
          </ul>
        </section>
        <section>
          <h3>SOPORTE</h3>
          <ul>
            <Navigation
              activeItemId={pathname}
              onSelect={({ itemId }) => {
                if (itemId !== '/caesar-vision') {
                  itemId = itemId.replace('/caesar-vision/', '');
                  const { internName, name } = cvList.find(
                    (el) => el.internCode === itemId
                  );
                  history.push({
                    pathname: `/caesar-vision/${itemId}`,
                    state: { brand: internName || name },
                  });
                }
              }}
              items={[
                {
                  title: 'Caesar Vision',
                  itemId: '/caesar-vision',
                  elemBefore: () => <FontAwesomeIcon icon={faPizzaSlice} />,
                  subNav: cvList.map(({ name, internName, internCode }) => ({
                    title: internName || name,
                    itemId: `/caesar-vision/${internCode}`,
                    name: 'hola',
                  })),
                },
              ]}
            />
            <li>
              <NavLink
                className="section"
                activeClassName="is-active"
                exact
                to="/onboardings"
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={faUserClock} />
                Onboardings
              </NavLink>
            </li>
            <li>
              <NavLink
                className="section"
                activeClassName="is-active"
                exact
                to="/cron-jobs"
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={faStopwatch20} />
                Cron Jobs
              </NavLink>
            </li>
            {/*<li>
              <NavLink
                className="section"
                activeClassName="is-active"
                exact
                to="/some-client"
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={faUserAstronaut} />
                Normales
              </NavLink>
            </li>*/}
            <li>
              <NavLink
                className="section"
                activeClassName="is-active"
                exact
                to="/update-csd"
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={faFileCertificate} />
                Actualizar CSD
              </NavLink>
            </li>
            {/*<li>
              <NavLink
                className="section"
                activeClassName="is-active"
                exact
                to="/cancel-invoice"
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={faExclamationTriangle} />
                Cancelar Factura
              </NavLink>
          </li>*/}
          </ul>
        </section>
        <section>
          <h3>INTERN</h3>
          <ul>
            <li>
              <NavLink
                className="section"
                //activeClassName="is-active"
                exact
                //to="/settings"
                to={pathname}
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={faCog} />
                Configuración
              </NavLink>
            </li>
          </ul>
        </section>
      </nav>
      <MediaQuery maxWidth={1279}>
        <div
          id="Blur"
          className={classnames('visooal-sideBlur', {
            show: open,
          })}
          onClick={onClickOption}
        ></div>
      </MediaQuery>
    </Fragment>
  );
}

SideNav.propTypes = {
  open: PropTypes.bool,
};

export default SideNav;
